// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"07c3bbbca2bcc061","487":"0337804e09078b1f","868":"4f40a4dbe1aa14f6","921":"4bc9759d5b65879f"}[chunkId] + ".js";
};